export default new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'inputBorderRadius',
    {
      var: 'components.input.global.borderRadius',
      cssVar: 'input-border-radius',
    },
  ],
  [
    'inputBorderWidth',
    {
      var: 'components.input.global.borderWidth',
      cssVar: 'input-border-width',
    },
  ],
  [
    'inputFont',
    {
      var: 'components.input.size.default.typography',
      cssVar: 'input-font',
    },
  ],
  [
    'inputColor',
    {
      var: 'components.input.global.color',
      cssVar: 'input-color',
    },
  ],
  [
    'inputHeight',
    {
      var: 'components.input.size.default.height',
      cssVar: 'input-height',
    },
  ],
  [
    'inputPlaceholderColor',
    {
      var: 'components.input.global.placeholderColor',
      cssVar: 'input-placeholder-color',
    },
  ],
  [
    'inputBg',
    {
      var: 'components.input.state.default.initial.bg',
      cssVar: 'input-bg',
      assignDefault: ['inputHoverBg'],
    },
  ],
  [
    'inputBorderColor',
    {
      var: 'components.input.state.default.initial.border',
      cssVar: 'input-border-color',
      assignDefault: ['inputHoverBorderColor'],
    },
  ],
  [
    'inputElevation',
    {
      var: 'input.state.default.initial.elevation',
      cssVar: 'input-elevation',
      assignDefault: ['inputHoverElevation', 'inputFocusElevation'],
    },
  ],
  [
    'inputHoverBg',
    {
      var: 'components.input.state.default.hover.bg',
      cssVar: 'input-hover-bg',
      assignDefault: ['inputFocusBg'],
    },
  ],
  [
    'inputHoverBorderColor',
    {
      var: 'components.input.state.default.hover.border',
      cssVar: 'input-hover-border-color',
      assignDefault: ['inputFocusBorderColor'],
    },
  ],
  [
    'inputHoverElevation',
    {
      var: 'components.input.state.default.hover.elevation',
      cssVar: 'input-hover-elevation',
    },
  ],
  [
    'inputFocusBg',
    {
      var: 'components.input.state.default.focus.bg',
      cssVar: 'input-focus-bg',
    },
  ],
  [
    'inputFocusBorderColor',
    {
      var: 'components.input.state.default.focus.border',
      cssVar: 'input-focus-border-color',
    },
  ],
  [
    'inputFocusElevation',
    {
      var: 'components.input.state.default.focus.elevation',
      cssVar: 'input-focus-elevation',
    },
  ],
  [
    'inputErrorBg',
    {
      var: 'components.input.state.error.initial.bg',
      cssVar: 'input-error-bg',
      assignDefault: ['inputErrorHoverBg'],
    },
  ],
  [
    'inputErrorBorderColor',
    {
      var: 'components.input.state.error.initial.border',
      cssVar: 'input-error-border-color',
      assignDefault: ['inputErrorHoverBorderColor'],
    },
  ],
  [
    'inputErrorElevation',
    {
      var: 'components.input.state.error.initial.elevation',
      cssVar: 'input-error-elevation',
      assignDefault: ['inputErrorHoverElevation', 'inputErrorFocusElevation'],
    },
  ],
  [
    'inputErrorHoverBg',
    {
      var: 'components.input.state.error.hover.bg',
      cssVar: 'input-error-hover-bg',
      assignDefault: ['inputErrorFocusBg'],
    },
  ],
  [
    'inputErrorHoverBorderColor',
    {
      var: 'components.input.state.error.hover.border',
      cssVar: 'input-error-hover-border-color',
      assignDefault: ['inputErrorFocusBorderColor'],
    },
  ],
  [
    'inputErrorHoverElevation',
    {
      var: 'components.input.state.error.hover.elevation',
      cssVar: 'input-error-hover-elevation',
    },
  ],
  [
    'inputErrorFocusBg',
    {
      var: 'components.input.state.error.focus.bg',
      cssVar: 'input-error-focus-bg',
    },
  ],
  [
    'inputErrorFocusBorderColor',
    {
      var: 'components.input.state.error.focus.border',
      cssVar: 'input-error-focus-border-color',
    },
  ],
  [
    'inputErrorFocusElevation',
    {
      var: 'components.input.state.error.focus.elevation',
      cssVar: 'input-error-focus-elevation',
    },
  ],
]);
